import { atomWithStorage, createJSONStorage } from "jotai/utils";
import type { SyncStringStorage } from "jotai/vanilla/utils/atomWithStorage";
import {
	PORTFOLIO_CONTRACT_STATE,
	type PortfolioContractStateKey,
} from "web_myplann/Portfolio/Components/Redesign/Filter/portfolioContractState";
import {
	PORTFOLIO_SORT,
	type PortfolioSortKey,
} from "web_myplann/Portfolio/Components/Redesign/Filter/portfolioSortKey";
import type { PortfolioCategoryId } from "web_myplann/Portfolio/Types/portfolioCategory";

export type PortfolioFilterState = {
	categories: PortfolioCategoryId[];
	contractState: PortfolioContractStateKey;
	sort: PortfolioSortKey;
	sortDesc: boolean;
};

export const defaultPortfolioFilterState: PortfolioFilterState = {
	categories: [],
	contractState: PORTFOLIO_CONTRACT_STATE.all,
	sort: PORTFOLIO_SORT.oblast,
	sortDesc: false,
};

export const isDefaultPortfolioFilter = (
	state: PortfolioFilterState,
): boolean =>
	state.sort === defaultPortfolioFilterState.sort &&
	state.sortDesc === defaultPortfolioFilterState.sortDesc &&
	state.contractState === defaultPortfolioFilterState.contractState &&
	state.categories.length === 0;

const PORTFOLIO_FILTER_STORAGE_KEY = "MYPLANN_PORTFOLIO_FILTER";

const memoryStorage: SyncStringStorage = {
	getItem: () => null,
	setItem: () => undefined,
	removeItem: () => undefined,
};

const baseStorage = createJSONStorage<PortfolioFilterState>(() =>
	typeof window === "undefined" ? memoryStorage : window.localStorage,
);

/**
 * Merges the persisted value into the default so a filter stored before a new
 * field existed does not resolve that field to undefined.
 */
const storage = {
	...baseStorage,
	getItem: (key: string, initialValue: PortfolioFilterState) => ({
		...initialValue,
		...baseStorage.getItem(key, initialValue),
	}),
};

export const portfolioFilterState = atomWithStorage<PortfolioFilterState>(
	PORTFOLIO_FILTER_STORAGE_KEY,
	defaultPortfolioFilterState,
	storage,
	{ getOnInit: true },
);
